import React, { useState } from "react";
import styles from "./CategoryTables.module.css";
import {
  FaRobot,
  FaLeaf,
  FaChild,
  FaRocket,
  FaBriefcase,
} from "react-icons/fa";
import { FaPerson } from "react-icons/fa6";

const CategoryTables = () => {
  const [activeCategory, setActiveCategory] = useState("junior");

  const categories = {
    junior: {
      age: "Grade 3-5",
      theme: "FOOD FOR ALL",
      score: "280 Points",
      sections: [
        {
          title: "ROBO GAME",
          points: "120 POINTS",
          icon: <FaRobot />,
          details: [
            "Aurdino bot and hardware to be only used",
            "Students design and build their own robot to solve the Robo game",
            "4 missions to be completed in 60 seconds",
            "Robot will run completely autonomous with coding technology on 6 by 4 feet mat",
            "No line following required",
          ],
        },
        {
          title: "ROBO CODING",
          points: "70 POINTS",
          icon: <FaChild />,
          details: [
            "Learners can have the saved code in laptop/tab to present to judges",
            "Students should be familiar with logic, syntax, flowchart, type of code used",
            "Automate the robot in unique way Block coding or Text coding",
          ],
        },
        {
          title: "ROBO ENGINEERING DESIGN",
          points: "70 POINTS",
          icon: <FaRocket />,
          details: [
            "Structural Engineering of Robot",
            "Explain how the design helps to solve missions on the mat and students to be aware of various hardware components of the Robot",
            "Explain the special add ons on Robot",
            "Explain about Hardware of Robot",
          ],
        },
        {
          title: "CORE VALUES",
          points: "20 POINTS",
          icon: <FaBriefcase />,
          details: [
            "Behaviour, Helping others, Teamwork, Collaboration, Fun on all 3 days",
            "From the day of competition training in school and both the days of competition students will be assessed on core values",
          ],
        },
      ],
    },
    senior: {
      age: "Grade 7-12",
      theme: "FOOD FOR ALL",
      score: "320 Points",
      sections: [
        {
          title: "PROJECT PRESENTATION",
          points: "120 POINTS",
          icon: <FaBriefcase />,
          details: [
            "Hardware or Software",
            "Pitch projects with related to problem solving with high professionalism on SDG",
            "Teams will follow theme of SDG or any other theme in sustainability",
          ],
        },
        {
          title: "ENGINEERING DESIGN",
          points: "80 POINTS",
          icon: <FaRocket />,
          details: [
            "The aesthetics, look and feel of Project is the major part of project design and students need to design the project according to there SDG",
            "Demonstrate all the features of the project",
          ],
        },
        {
          title: "PROJECT AUTOMATION",
          points: "80 POINTS",
          icon: <FaRobot />,
          details: [
            "Explain the logic and how the project works as movement of Robot, LED Glow, and more automations",
            "Projects as water waste management, tech in agriculture, Traffic problem etc...",
          ],
        },
        {
          title: "CORE VALUES",
          points: "40 POINTS",
          icon: <FaChild />,
          details: [
            "Behaviour, Helping others, Teamwork, Collaboration, Fun",
            "Active and high energy from team members",
          ],
        },
      ],
    },
  };

  const activeData = categories[activeCategory];

  return (
    <div className={styles.categoryTablesBG}>
      <div className={styles.categoryTables}>
        <div className={styles.heading}>Point System</div>
        <div className={styles.switchers}>
          <button
            className={`${styles.switchButton} ${
              activeCategory === "junior" ? styles.active : ""
            }`}
            onClick={() => setActiveCategory("junior")}
          >
            <FaRocket /> Junior Category
          </button>
          <button
            className={`${styles.switchButton} ${
              activeCategory === "senior" ? styles.active : ""
            }`}
            onClick={() => setActiveCategory("senior")}
          >
            <FaBriefcase /> Senior Category
          </button>
        </div>

        <div className={styles.categoryInfo}>
          <div className={styles.header}>
            <span>AGE: {activeData.age}</span>
            <span>THEME: {activeData.theme}</span>
            <span>SCORE: {activeData.score}</span>
          </div>

          <div className={styles.sections}>
            {activeData.sections.map((section, index) => (
              <div key={index} className={styles.section}>
                <h3>
                  {section.icon}
                  {section.title} <span>({section.points})</span>
                </h3>
                <ul>
                  {section.details.map((detail, idx) => (
                    <li key={idx}>{detail}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryTables;
